import { StatusToast } from '@fiverr-private/orca';

export const OPTIONS = {
    location: StatusToast.LOCATIONS.TOP_CENTER,
    duration: 3000,
};
